import React, { useEffect, useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { getCourses, getLecturers } from '../services/api';

export default function Schedule() {
  const { t, lang } = useLang();
  const [courses, setCourses] = useState<any[]>([]);
  const [lecturers, setLecturers] = useState<any[]>([]);

  useEffect(() => {
    getCourses().then(res => setCourses(res.data)).catch(() => {});
    getLecturers().then(res => setLecturers(res.data)).catch(() => {});
  }, []);

  const days = [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday')];
  const timeSlots = [
    '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
    '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
    '17:00', '17:30', '18:00'
  ];

  const getLecturerName = (id: string) => {
    const l = lecturers.find(lec => lec.id === id);
    if (!l) return '';
    if (lang === 'ar' && l.firstNameAr) return `${l.firstNameAr} ${l.lastNameAr}`;
    return `${l.firstName} ${l.lastName}`;
  };

  const getScheduleForSlot = (dayIndex: number, time: string) => {
    const results: any[] = [];
    courses.forEach(course => {
      course.schedule?.forEach((s: any) => {
        if (s.day === dayIndex && s.startTime === time) {
          results.push({
            ...course,
            room: s.room,
            startTime: s.startTime,
            endTime: s.endTime
          });
        }
      });
    });
    return results;
  };

  return (
    <div>
      <div className="page-title">
        <span className="page-title-text">🗓️ {t('weeklySchedule')}</span>
      </div>

      <div className="page-section" style={{ overflowX: 'auto' }}>
        <table className="schedule-table">
          <thead>
            <tr>
              <th>{t('time')}</th>
              {days.map((day, i) => (
                <th key={i}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {timeSlots.map(time => {
              const hasContent = days.some((_, di) => getScheduleForSlot(di, time).length > 0);
              if (!hasContent && !['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'].includes(time)) {
                return null;
              }
              return (
                <tr key={time}>
                  <td style={{ fontWeight: 600, background: '#f8f9fa' }}>{time}</td>
                  {days.map((_, dayIndex) => {
                    const items = getScheduleForSlot(dayIndex, time);
                    return (
                      <td key={dayIndex}>
                        {items.map((item, i) => (
                          <div key={i} className="schedule-cell">
                            <strong>{lang === 'ar' && item.nameAr ? item.nameAr : item.name}</strong>
                            <br />
                            <span style={{ fontSize: 11, color: '#666' }}>
                              {getLecturerName(item.lecturerId)} | {item.room}
                            </span>
                            <br />
                            <span style={{ fontSize: 10, color: '#999' }}>
                              {item.startTime} - {item.endTime}
                            </span>
                          </div>
                        ))}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="page-section" style={{ marginTop: 16 }}>
        <h3 style={{ color: '#7B1FA2', marginBottom: 12 }}>📚 {t('courseList')}</h3>
        <div className="stats-grid">
          {courses.map(c => (
            <div key={c.id} className="stat-card" style={{ borderRightColor: '#81D4FA' }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#7B1FA2', marginBottom: 4 }}>
                {lang === 'ar' && c.nameAr ? c.nameAr : c.name}
              </div>
              <div style={{ fontSize: 12, color: '#666' }}>
                {c.code} | {getLecturerName(c.lecturerId)}
              </div>
              <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                {c.schedule?.map((s: any, i: number) => (
                  <span key={i}>
                    {days[s.day]} {s.startTime}-{s.endTime} ({s.room})
                    {i < c.schedule.length - 1 ? ' | ' : ''}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
